import { gql } from '@apollo/client';

export const fetchEntitlementsTotalCountForCartQuery = gql`
  query fetchEntitlementsTotalCountForCart(
    $id: ID!
    $filterOptions: [FilterOption]
    $searchOptions: ConnectionSearchOptions
  ) {
    transactionAccount(id: $id) {
      productSubscriptions(filterOptions: $filterOptions, searchOptions: $searchOptions) {
        totalCount
      }
    }
  }
`;
